// import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";

// import { ChevronDown, ChevronLeft, ChevronRight, Search, CalendarDays, Car, CarFront, Package, Wrench, Info } from "lucide-react";

// import UserLayout from "../components/Userlayout";

// import RequestPartModal from "../components/RequestPartModal";

// import "./FindPartsResponsive.css";

// import { MAKES_DATA, PARTS_DATA } from "./Data";

// import heroBg from "../img/search.jpg";

// const STORE_ID = "cmr7wh4ey030do35ydeft8ukq";

// const API_KEY = "4560a5d74bfb3810ee113b21f210546d";

// const BASE_URL = `https://api-sb.allgoodparts.com.au/api/storefront/stores/${STORE_ID}/parts`;

// const MAIN_DOMAIN = "https://allgoodparts.com.au";

// const FILTER_CHAIN = [

//   { key: "year", param: "filter.p.m.custom.year", placeholder: "Select Year" },

//   { key: "make", param: "filter.p.m.custom.make", placeholder: "Select Make" },

//   { key: "model", param: "filter.p.m.custom.model", placeholder: "Select Model" },

//   { key: "part", param: "filter.p.m.custom.part", placeholder: "Select Part" },

// ];

// const MOCK_FACETS = {

//   year: ["2024", "2023", "2022", "2021", "2020"],

//   make: MAKES_DATA.map((m) => m.name),

//   model: ["Model A", "Model B", "Model C"],

//   part: PARTS_DATA.map((p) => p.name),

// };

// function normalizeValue(value) {

//   return String(value || "")

//     .trim()

//     .toLowerCase()

//     .replace(/&/g, "and")

//     .replace(/[\_-]+/g, " ")

//     .replace(/\s+/g, " ")

//     .replace(/[^\w\s]/g, "");

// }

// function partToKey(value) {
//   return String(value || "").trim().toLowerCase()
//     .replace(/&/g, "and")
//     .replace(/\./g, "")
//     .replace(/[()]/g, "")
//     .replace(/[\/+]/g, "-")
//     .replace(/\s+/g, "-")
//     .replace(/-+/g, "-")
//     .replace(/^-|-$/g, "");
// }

// const MAKE_IMAGE_MAP = new Map(

//   MAKES_DATA.map((item) => [normalizeValue(item.name), item.image])

// );

// const PART_IMAGE_MAP = new Map(

//   PARTS_DATA.map((item) => [partToKey(item.name), item.image])

// );

// function getFilterImage(filterKey, value) {

//   if (!value) return "";

//   if (filterKey === "make") return MAKE_IMAGE_MAP.get(normalizeValue(value)) || "";

//   if (filterKey === "part") return PART_IMAGE_MAP.get(partToKey(value)) || "";

//   return "";

// }

// function FilterIcon({ filterKey, value, className = "h-6 w-6" }) {

//   const image = getFilterImage(filterKey, value);

//   if (image) {

//     return (

//       <img

//         src={image}

//         alt=""

//         className={`${className} shrink-0 object-contain`}

//         onError={(event) => {

//           event.currentTarget.style.display = "none";

//         }}

//       />

//     );

//   }

//   if (filterKey === "year") {

//     return <CalendarDays className={`${className} shrink-0 text-gray-400`} />;

//   }

//   if (filterKey === "model") {

//     return <Car className={`${className} shrink-0 text-gray-400`} />;

//   }

//   return <Package className={`${className} shrink-0 text-gray-400`} />;

// }

// function SearchableSelect({ filterKey, placeholder, options, value, onChange, disabled }) {

//   const [open, setOpen] = useState(false);

//   const [query, setQuery] = useState("");

//   const rootRef = useRef(null);

//   useEffect(() => {

//     const close = (event) => {

//       if (rootRef.current && !rootRef.current.contains(event.target)) {

//         setOpen(false);

//         setQuery("");

//       }

//     };

//     document.addEventListener("mousedown", close);

//     return () => document.removeEventListener("mousedown", close);

//   }, []);

//   const filtered = useMemo(

//     () =>

//       options.filter((option) =>

//         String(option).toLowerCase().includes(query.toLowerCase())

//       ),

//     [options, query]

//   );

//   return (

//     <div ref={rootRef} className="relative w-full">

//       <button

//         type="button"

//         disabled={disabled}

//         onClick={() => !disabled && setOpen((current) => !current)}

//         className={`agp-finder-select flex h-12 w-full items-center gap-3 rounded-md bg-[#f8f8fa] px-4 text-left text-[13px]

//           transition ${disabled ? "cursor-default opacity-50" : "cursor-pointer hover:bg-[#f4f4f7]"}

//           ${value ? "font-medium text-[#30343c]" : "text-[#777b84]"}`}

//       >

//         <span className="agp-finder-select-icon"><FilterIcon filterKey={filterKey} value={value} className="h-5 w-5" /></span>

//         <span className="min-w-0 flex-1 truncate">{value || placeholder}</span>

//         <ChevronDown

//           size={18}

//           strokeWidth={2}

//           className={`shrink-0 text-[#252a73] transition-transform ${open ? "rotate-180" : ""}`}

//         />

//       </button>

//       {open && !disabled && (

//         <div className="agp-finder-dropdown absolute left-0 top-full z-[100] mt-2 w-full min-w-[220px] overflow-hidden rounded-md border border-[#e1e2e5] bg-white shadow-xl">

//           <div className="flex items-center gap-2 border-b border-gray-100 px-3 py-2">

//             <Search size={14} className="shrink-0 text-gray-400" />

//             <input

//               autoFocus

//               value={query}

//               onChange={(event) => setQuery(event.target.value)}

//               placeholder="Search..."

//               className="w-full bg-transparent text-[13px] text-gray-700 outline-none placeholder:text-gray-400"

//             />

//           </div>

//           <div className="max-h-64 overflow-y-auto py-1">

//             {filtered.length === 0 ? (

//               <div className="px-3 py-3 text-[13px] text-gray-400">No matches</div>

//             ) : (

//               filtered.map((option) => (

//                 <button

//                   key={option}

//                   type="button"

//                   onClick={() => {

//                     onChange(option);

//                     setOpen(false);

//                     setQuery("");

//                   }}

//                   className={`flex w-full items-center gap-3 px-3 py-2.5 text-left text-[13px] transition

//                     hover:bg-[#fff1f2] ${option === value

//                       ? "bg-[#fff4f4] font-semibold text-[#dd1921]"

//                       : "text-[#343840]"

//                     }`}

//                 >

//                   <FilterIcon filterKey={filterKey} value={option} className="h-7 w-7" />

//                   <span className="min-w-0 flex-1 truncate">{option}</span>

//                 </button>

//               ))

//             )}

//           </div>

//         </div>

//       )}

//     </div>

//   );

// }

// function usePartsFinder() {

//   const [selections, setSelections] = useState({});

//   const [facets, setFacets] = useState({ year: [], make: [], model: [], part: [] });

//   const [loading, setLoading] = useState(false);

//   const fetchFacets = useCallback(async (params) => {

//     try {

//       const qs = new URLSearchParams(params).toString();

//       const res = await fetch(qs ? `${BASE_URL}?${qs}` : BASE_URL, {

//         headers: { "x-storefront-key": API_KEY },

//       });

//       if (!res.ok) throw new Error(`Filter API error: ${res.status}`);

//       const data = await res.json();

//       return data.facets || {};

//     } catch {

//       // Fallback so the UI stays usable without a live/reachable API.

//       return {

//         year: { selected: MOCK_FACETS.year },

//         make: { selected: MOCK_FACETS.make },

//         model: { selected: MOCK_FACETS.model },

//         part: { selected: MOCK_FACETS.part },

//       };

//     }

//   }, []);

//   // initial load

//   useEffect(() => {

//     (async () => {

//       setLoading(true);

//       const data = await fetchFacets({});

//       setFacets((prev) => ({ ...prev, year: data.year?.selected || [] }));

//       setLoading(false);

//     })();

//   }, [fetchFacets]);

//   const selectValue = useCallback(

//     async (key, value) => {

//       const order = FILTER_CHAIN.map((f) => f.key);

//       const idx = order.indexOf(key);

//       const nextSelections = { ...selections, [key]: value };

//       // clear downstream selections

//       order.slice(idx + 1).forEach((k) => delete nextSelections[k]);

//       setSelections(nextSelections);

//       // clear downstream facet options

//       setFacets((prev) => {

//         const next = { ...prev };

//         order.slice(idx + 1).forEach((k) => (next[k] = []));

//         return next;

//       });

//       const nextKey = order[idx + 1];

//       if (!nextKey) return;

//       setLoading(true);

//       const data = await fetchFacets(nextSelections);

//       setFacets((prev) => ({ ...prev, [nextKey]: data[nextKey]?.selected || [] }));

//       setLoading(false);

//     },

//     [selections, fetchFacets]

//   );

//   const reset = useCallback(async () => {

//     setSelections({});

//     setLoading(true);

//     const data = await fetchFacets({});

//     setFacets({ year: data.year?.selected || [], make: [], model: [], part: [] });

//     setLoading(false);

//   }, [fetchFacets]);

//   return { selections, facets, loading, selectValue, reset };

// }

// function PartsFinder({ onSearch }) {

//   const { selections, facets, selectValue } = usePartsFinder();

//   const handleSearch = () => {

//     const params = {};

//     FILTER_CHAIN.forEach(({ key, param }) => {

//       if (selections[key]) params[param] = selections[key];

//     });

//     if (!Object.keys(params).length) return;

//     onSearch?.(params);

//   };

//   return (

//     <div className="agp-finder-grid grid grid-cols-1 gap-3 md:grid-cols-[repeat(4,minmax(0,1fr))\_1.35fr] md:gap-2">

//       {FILTER_CHAIN.map(({ key, placeholder }, index) => {

//         const disabled =

//           index > 0 && !selections[FILTER_CHAIN[index - 1].key];

//         return (

//           <SearchableSelect

//             key={key}

//             filterKey={key}

//             placeholder={placeholder}

//             options={facets[key] || []}

//             value={selections[key] || ""}

//             disabled={index > 0 && disabled}

//             onChange={(value) => selectValue(key, value)}

//           />

//         );

//       })}

//       <button

//         type="button"

//         onClick={handleSearch}

//         className="agp-finder-submit h-12 w-full rounded-md bg-[#0b7be7] px-5 text-[13px] font-medium text-white transition hover:bg-[#086fd1]"

//       >

//         SEARCH PART

//       </button>

//     </div>

//   );

// }

// const BASE = "https://allgoodparts.com.au";

// const DESTINATIONS = {

//   part: `${BASE}/pages/all-parts`,

//   make: `${BASE}/collections/car-wreckers-in-melbourne`,

// };

// const normalize = (name) => String(name || "").trim().toLowerCase().replace(/[\_-]+/g, " ").replace(/\s+/g, " ");

// function DirectoryCarousel({ title, accent, items, kind }) {

//   const trackRef = useRef(null);

//   const [position, setPosition] = useState({ start: true, end: false });

//   const [active, setActive] = useState(0);

//   const pointer = useRef(null);

//   const [dragging, setDragging] = useState(false);

//   const cards = useMemo(() => Array.from(new Map(items.filter((x) => x?.name).map((x) => [normalize(x.name), x])).values()), [items]);

//   const measure = useCallback(() => {

//     const el = trackRef.current;

//     if (!el) return;

//     const card = el.querySelector(".agp-dir-card");

//     const stride = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap || 0) : 1;

//     setActive(Math.max(0, Math.round(el.scrollLeft / Math.max(1, stride))));

//     setPosition({ start: el.scrollLeft <= 3, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 3 });

//   }, []);

//   useEffect(() => {

//     measure();

//     const observer = new ResizeObserver(measure);

//     if (trackRef.current) observer.observe(trackRef.current);

//     return () => observer.disconnect();

//   }, [measure, cards.length]);

//   const slide = (dir) => {

//     const el = trackRef.current;

//     if (!el) return;

//     const card = el.querySelector(".agp-dir-card");

//     if (!card) return;

//     const stride = card.getBoundingClientRect().width + parseFloat(getComputedStyle(el).gap || 0);

//     el.scrollBy({ left: stride * dir, behavior: "smooth" });

//   };

//   const itemUrl = (item) => `${BASE}/collections/all?${encodeURIComponent(kind === "make" ? "filter.p.m.custom.make" : "filter.p.m.custom.part")}=${encodeURIComponent(item.name)}`;

//   return (

//     <section className="agp-dir-section" aria-label={`Browse ${title}`}>

//       <div className="agp-dir-heading">

//         <div>

//           <h2>{title} <span>{accent}</span></h2>

//           <p>Swipe or use the arrows to browse more options.</p>

//         </div>

//         <div className="agp-dir-controls">

//           <button type="button" aria-label={`Previous ${title}`} disabled={position.start} onClick={() => slide(-1)}><ChevronLeft size={20} /></button>

//           <button type="button" aria-label={`Next ${title}`} disabled={position.end} onClick={() => slide(1)}><ChevronRight size={20} /></button>

//         </div>

//       </div>

//       <div className="agp-dir-track" ref={trackRef} onScroll={measure}

//         onPointerDown={(e) => { if (e.pointerType !== "mouse" || e.button !== 0) return; pointer.current = { x: e.clientX, left: e.currentTarget.scrollLeft, moved: false }; }}

//         onPointerMove={(e) => { if (!pointer.current) return; const dx = e.clientX - pointer.current.x; if (Math.abs(dx) > 5) { pointer.current.moved = true; setDragging(true); e.currentTarget.scrollLeft = pointer.current.left - dx; } }}

//         onPointerUp={() => { if (pointer.current?.moved) { const el = trackRef.current; if (el) { el.dataset.justDragged = "1"; setTimeout(() => { if (el) delete el.dataset.justDragged; }, 100); } } pointer.current = null; setDragging(false); }}

//         onPointerCancel={() => { pointer.current = null; setDragging(false); }}

//         style={{ cursor: dragging ? "grabbing" : undefined }}>

//         {cards.map((item, i) => (

//           <a href={itemUrl(item)} key={`${kind}-${normalize(item.name)}`} className={`agp-dir-card agp-dir-card--${kind}`} draggable="false" onClick={(e) => { if (e.currentTarget.closest(".agp-dir-track")?.dataset.justDragged) e.preventDefault(); }}>

//             <span className="agp-dir-art">

//               {item.image ? <img src={item.image} alt={item.name} loading={i < 8 ? "eager" : "lazy"} draggable="false" onError={(e) => { e.currentTarget.style.display = "none"; }} /> : kind === "make" ? <CarFront size={36} /> : <Wrench size={36} />}

//             </span>

//             <span className="agp-dir-name">{String(item.name).replace(/\_/g, " ")}</span>

//           </a>

//         ))}

//       </div>

//       <div className="agp-dir-footer">

//         <div className="agp-dir-progress" aria-hidden="true"><span style={{ width: `${Math.max(8, 100 * Math.min(1, (active + 1) / Math.max(1, cards.length - 2))) }%` }} /></div>

//         <a className="agp-dir-view-all" href={DESTINATIONS[kind]}>VIEW ALL <ChevronRight size={16}/></a>

//       </div>

//     </section>

//   );

// }

// function PartsDirectoryCarousel() {

//   return (

//     <div className="agp-dir-root">

//       <DirectoryCarousel title="Browse by" accent="Make" items={MAKES_DATA} kind="make" />

//       <DirectoryCarousel title="Browse by" accent="Part" items={PARTS_DATA} kind="part" />

//     </div>

//   );

// }

// const DIRECTORY_STYLES = `
// .agp-dir-root{display:grid;gap:14px;padding:12px 0 10px;min-width:0}

// .agp-dir-section{background:#fff;border:1px solid #eceef1;border-radius:16px;padding:16px 16px 15px;min-width:0;overflow:hidden}

// .agp-dir-heading{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px}

// .agp-dir-heading h2{margin:0;font-size:21px;font-weight:750;color:#162033;line-height:1.25}

// .agp-dir-heading h2 span{color:#c41620}

// .agp-dir-heading p{margin:5px 0 0;color:#8a909a;font-size:12px}

// .agp-dir-controls{display:flex;gap:8px;flex-shrink:0}

// .agp-dir-controls button{width:36px;height:36px;display:grid;place-items:center;border:1px solid #e0e3e9;background:#fff;border-radius:10px;color:#172039;cursor:pointer;transition:.2s}

// .agp-dir-controls button:not(:disabled):hover{background:#c41620;color:#fff;border-color:#c41620}

// .agp-dir-controls button:disabled{opacity:.32;cursor:default}

// .agp-dir-track{display:flex;gap:16px;overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scroll-padding-left:1px;scrollbar-width:none;padding:2px 2px 12px;user-select:none;-webkit-overflow-scrolling:touch;touch-action:pan-x pan-y}

// .agp-dir-track::-webkit-scrollbar{display:none}

// .agp-dir-card{flex:0 0 calc((100% - 80px)/6);min-width:0;min-height:142px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:12px 8px;background:#fafafa;border:1px solid #e0e2e6;border-radius:12px;text-decoration:none!important;color:#30343c;scroll-snap-align:start;box-shadow:0 2px 5px #0f172a08;transition:border-color .2s,box-shadow .2s,transform .2s}

// .agp-dir-card:hover,.agp-dir-card:focus-visible{border-color:#d01d2a;box-shadow:0 5px 14px #0f172a16;transform:translateY(-2px);outline:none}

// .agp-dir-art{height:67px;width:100%;display:grid;place-items:center;color:#a7aab1;pointer-events:none}

// .agp-dir-art img{max-width:100%;width:auto;height:64px;object-fit:contain;pointer-events:none}

// .agp-dir-card--part .agp-dir-art{width:80px;height:80px;border-radius:50%;background:#fff5f5;border:1px solid #f4d5d7}

// .agp-dir-card--part .agp-dir-art img{height:56px;max-width:65px}

// .agp-dir-name{font-size:13px;font-weight:650;text-align:center;line-height:1.35;text-transform:capitalize;overflow-wrap:anywhere;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}

// .agp-dir-footer{display:flex;align-items:center;justify-content:center;position:relative;min-height:62px;padding-top:12px}

// .agp-dir-progress{position:absolute;left:0;bottom:14px;width:88px;height:4px;border-radius:5px;background:#ebedf1;overflow:hidden}

// .agp-dir-progress span{display:block;height:100%;border-radius:5px;background:#bf1320;transition:width .2s}

// .agp-dir-view-all{display:inline-flex;justify-content:center;align-items:center;gap:9px;min-width:155px;min-height:43px;padding:0 18px;border:2px solid #b90e1a;border-radius:99px;font-size:12px;font-weight:750;color:#b90e1a;text-decoration:none!important;transition:.2s}

// .agp-dir-view-all:hover{background:#b90e1a;color:#fff}

// @media(max-width:1023px){.agp-dir-card{flex-basis:calc((100% - 48px)/4)}}

// @media(max-width:767px){.agp-dir-root{gap:14px;padding:14px 0}.agp-dir-section{padding:15px 12px 13px;border-radius:12px}.agp-dir-heading{margin-bottom:13px}.agp-dir-heading h2{font-size:17px}.agp-dir-heading p{font-size:10px}.agp-dir-controls button{width:31px;height:31px;border-radius:8px}.agp-dir-track{gap:10px}.agp-dir-card{flex-basis:calc((100% - 10px)/2);min-height:126px;padding:9px 6px}.agp-dir-name{font-size:12px}.agp-dir-art{height:61px}.agp-dir-art img{height:58px}.agp-dir-card--part .agp-dir-art{height:67px;width:67px}.agp-dir-card--part .agp-dir-art img{height:48px}.agp-dir-footer{min-height:57px}.agp-dir-view-all{min-width:120px;min-height:39px;font-size:11px}.agp-dir-progress{width:50px;bottom:17px}}

// `;

// export default function FindPartsPage() {

//   const [requestOpen, setRequestOpen] = useState(false);

//   const isAppView = new URLSearchParams(

//     window.location.search

//   ).get("app") === "1";

//   const handleSearch = (params) => {

//     const query = new URLSearchParams(params).toString();

//     window.location.href = `${MAIN_DOMAIN}/collections/all?${query}`;

//   };

//   const pageContent = (

//     <main className="agp-find-page min-h-screen bg-[#f7f7f8] pb-8">
//       <style>{DIRECTORY_STYLES}</style>

//       <div className="agp-page-wrap agp-find-page-wrap">

//         <section className="agp-find-hero" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,.69), rgba(0,0,0,.75)), url(${heroBg})` }}>

//           <h1 className="agp-find-title">Find <span>Parts</span></h1>

//           <PartsFinder onSearch={handleSearch} />

//           <div className="agp-find-help">

//             <Info size={14} fill="white" color="#303030" />

//             <span>Need help finding a part?</span>

//             <button type="button" onClick={() => setRequestOpen(true)}>Click here</button>

//           </div>

//         </section>

//         <div className="agp-find-directories"><PartsDirectoryCarousel /></div>

//       </div>

//       <RequestPartModal

//         open={requestOpen}

//         onClose={() => setRequestOpen(false)}

//         onSubmitted={() => { setRequestOpen(false); window.location.href = "/quotes"; }}

//       />

//     </main>

//   );

//   return isAppView

//     ? pageContent

//     : <UserLayout>{pageContent}</UserLayout>;

// }


import React, { useState, useEffect, useRef, useCallback, useMemo, useContext, createContext } from "react";

import { ChevronDown, ChevronLeft, ChevronRight, Search, CalendarDays, Car, CarFront, Package, Wrench, Info } from "lucide-react";

import UserLayout from "../components/Userlayout";

import RequestPartModal from "../components/RequestPartModal";

import "./FindPartsResponsive.css";

import heroBg from "../img/search.jpg";

const STORE_ID = "cmr7wh4ey030do35ydeft8ukq";

const API_KEY = "4560a5d74bfb3810ee113b21f210546d";

const BASE_URL = `https://api-sb.allgoodparts.com.au/api/storefront/stores/${STORE_ID}/parts`;

const MAIN_DOMAIN = "https://allgoodparts.com.au";

/* ------------------------------------------------------------------ */
/* Shopify Storefront API config (Browse by Make / Browse by Part)     */
/* ------------------------------------------------------------------ */

// Storefront API endpoint works on the custom domain or the *.myshopify.com domain.
const SHOPIFY_DOMAIN = "allgoodparts.com.au";

const SHOPIFY_API_VERSION = "2026-07";

// Public Storefront API access token (Shopify admin → Apps → Develop apps / Headless channel).
const SHOPIFY_STOREFRONT_TOKEN = "88e141269621d96bb1b7be7491ad5615";

const SHOPIFY_GRAPHQL_URL = `https://${SHOPIFY_DOMAIN}/api/${SHOPIFY_API_VERSION}/graphql.json`;

const DIRECTORY_CACHE_KEY = "agp-directory-collections-v1";

const DIRECTORY_CACHE_TTL = 30 * 60 * 1000; // 30 minutes

const FILTER_CHAIN = [

  { key: "year", param: "filter.p.m.custom.year", placeholder: "Select Year" },

  { key: "make", param: "filter.p.m.custom.make", placeholder: "Select Make" },

  { key: "model", param: "filter.p.m.custom.model", placeholder: "Select Model" },

  { key: "part", param: "filter.p.m.custom.part", placeholder: "Select Part" },

];

// Make / Part fallback options come from the Shopify collections (see fetchFacets).
const MOCK_FACETS = {

  year: ["2024", "2023", "2022", "2021", "2020"],

  model: ["Model A", "Model B", "Model C"],

};

function normalizeValue(value) {

  return String(value || "")

    .trim()

    .toLowerCase()

    .replace(/&/g, "and")

    .replace(/[\_-]+/g, " ")

    .replace(/\s+/g, " ")

    .replace(/[^\w\s]/g, "");

}

function partToKey(value) {
  return String(value || "").trim().toLowerCase()
    .replace(/&/g, "and")
    .replace(/\./g, "")
    .replace(/[()]/g, "")
    .replace(/[\/+]/g, "-")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

// Make / Part images for the dropdown icons, built from the Shopify collections.
const DirectoryImagesContext = createContext({ makeImages: new Map(), partImages: new Map() });

function buildImageMaps(data) {

  return {

    makeImages: new Map((data?.make || []).map((item) => [normalizeValue(item.name), item.image])),

    partImages: new Map((data?.part || []).map((item) => [partToKey(item.name), item.image])),

  };

}

function getFilterImage(filterKey, value, { makeImages, partImages }) {

  if (!value) return "";

  if (filterKey === "make") return makeImages.get(normalizeValue(value)) || "";

  if (filterKey === "part") return partImages.get(partToKey(value)) || "";

  return "";

}

function FilterIcon({ filterKey, value, className = "h-6 w-6" }) {

  const imageMaps = useContext(DirectoryImagesContext);

  const image = getFilterImage(filterKey, value, imageMaps);

  if (image) {

    return (

      <img

        src={image}

        alt=""

        className={`${className} shrink-0 object-contain`}

        onError={(event) => {

          event.currentTarget.style.display = "none";

        }}

      />

    );

  }

  if (filterKey === "year") {

    return <CalendarDays className={`${className} shrink-0 text-gray-400`} />;

  }

  if (filterKey === "model") {

    return <Car className={`${className} shrink-0 text-gray-400`} />;

  }

  return <Package className={`${className} shrink-0 text-gray-400`} />;

}

function SearchableSelect({ filterKey, placeholder, options, value, onChange, disabled }) {

  const [open, setOpen] = useState(false);

  const [query, setQuery] = useState("");

  const rootRef = useRef(null);

  useEffect(() => {

    const close = (event) => {

      if (rootRef.current && !rootRef.current.contains(event.target)) {

        setOpen(false);

        setQuery("");

      }

    };

    document.addEventListener("mousedown", close);

    return () => document.removeEventListener("mousedown", close);

  }, []);

  const filtered = useMemo(

    () =>

      options.filter((option) =>

        String(option).toLowerCase().includes(query.toLowerCase())

      ),

    [options, query]

  );

  return (

    <div ref={rootRef} className="relative w-full">

      <button

        type="button"

        disabled={disabled}

        onClick={() => !disabled && setOpen((current) => !current)}

        className={`agp-finder-select flex h-12 w-full items-center gap-3 rounded-md bg-[#f8f8fa] px-4 text-left text-[13px]

          transition ${disabled ? "cursor-default opacity-50" : "cursor-pointer hover:bg-[#f4f4f7]"}

          ${value ? "font-medium text-[#30343c]" : "text-[#777b84]"}`}

      >

        <span className="agp-finder-select-icon"><FilterIcon filterKey={filterKey} value={value} className="h-5 w-5" /></span>

        <span className="min-w-0 flex-1 truncate">{value || placeholder}</span>

        <ChevronDown

          size={18}

          strokeWidth={2}

          className={`shrink-0 text-[#252a73] transition-transform ${open ? "rotate-180" : ""}`}

        />

      </button>

      {open && !disabled && (

        <div className="agp-finder-dropdown absolute left-0 top-full z-[100] mt-2 w-full min-w-[220px] overflow-hidden rounded-md border border-[#e1e2e5] bg-white shadow-xl">

          <div className="flex items-center gap-2 border-b border-gray-100 px-3 py-2">

            <Search size={14} className="shrink-0 text-gray-400" />

            <input

              autoFocus

              value={query}

              onChange={(event) => setQuery(event.target.value)}

              placeholder="Search..."

              className="w-full bg-transparent text-[13px] text-gray-700 outline-none placeholder:text-gray-400"

            />

          </div>

          <div className="max-h-64 overflow-y-auto py-1">

            {filtered.length === 0 ? (

              <div className="px-3 py-3 text-[13px] text-gray-400">No matches</div>

            ) : (

              filtered.map((option) => (

                <button

                  key={option}

                  type="button"

                  onClick={() => {

                    onChange(option);

                    setOpen(false);

                    setQuery("");

                  }}

                  className={`flex w-full items-center gap-3 px-3 py-2.5 text-left text-[13px] transition

                    hover:bg-[#fff1f2] ${option === value

                      ? "bg-[#fff4f4] font-semibold text-[#dd1921]"

                      : "text-[#343840]"

                    }`}

                >

                  <FilterIcon filterKey={filterKey} value={option} className="h-7 w-7" />

                  <span className="min-w-0 flex-1 truncate">{option}</span>

                </button>

              ))

            )}

          </div>

        </div>

      )}

    </div>

  );

}

function usePartsFinder() {

  const [selections, setSelections] = useState({});

  const [facets, setFacets] = useState({ year: [], make: [], model: [], part: [] });

  const [loading, setLoading] = useState(false);

  const fetchFacets = useCallback(async (params) => {

    try {

      const qs = new URLSearchParams(params).toString();

      const res = await fetch(qs ? `${BASE_URL}?${qs}` : BASE_URL, {

        headers: { "x-storefront-key": API_KEY },

      });

      if (!res.ok) throw new Error(`Filter API error: ${res.status}`);

      const data = await res.json();

      return data.facets || {};

    } catch {

      // Fallback so the UI stays usable without a live/reachable API.
      // Make / Part options come from the Shopify collections.

      const directory = await loadDirectory().catch(() => null);

      return {

        year: { selected: MOCK_FACETS.year },

        make: { selected: (directory?.make || []).map((item) => item.name.replace(/_/g, " ")) },

        model: { selected: MOCK_FACETS.model },

        part: { selected: (directory?.part || []).map((item) => item.name) },

      };

    }

  }, []);

  // initial load

  useEffect(() => {

    (async () => {

      setLoading(true);

      const data = await fetchFacets({});

      setFacets((prev) => ({ ...prev, year: data.year?.selected || [] }));

      setLoading(false);

    })();

  }, [fetchFacets]);

  const selectValue = useCallback(

    async (key, value) => {

      const order = FILTER_CHAIN.map((f) => f.key);

      const idx = order.indexOf(key);

      const nextSelections = { ...selections, [key]: value };

      // clear downstream selections

      order.slice(idx + 1).forEach((k) => delete nextSelections[k]);

      setSelections(nextSelections);

      // clear downstream facet options

      setFacets((prev) => {

        const next = { ...prev };

        order.slice(idx + 1).forEach((k) => (next[k] = []));

        return next;

      });

      const nextKey = order[idx + 1];

      if (!nextKey) return;

      setLoading(true);

      const data = await fetchFacets(nextSelections);

      setFacets((prev) => ({ ...prev, [nextKey]: data[nextKey]?.selected || [] }));

      setLoading(false);

    },

    [selections, fetchFacets]

  );

  const reset = useCallback(async () => {

    setSelections({});

    setLoading(true);

    const data = await fetchFacets({});

    setFacets({ year: data.year?.selected || [], make: [], model: [], part: [] });

    setLoading(false);

  }, [fetchFacets]);

  return { selections, facets, loading, selectValue, reset };

}

function PartsFinder({ onSearch }) {

  const { selections, facets, selectValue } = usePartsFinder();

  const handleSearch = () => {

    const params = {};

    FILTER_CHAIN.forEach(({ key, param }) => {

      if (selections[key]) params[param] = selections[key];

    });

    if (!Object.keys(params).length) return;

    onSearch?.(params);

  };

  return (

    <div className="agp-finder-grid grid grid-cols-1 gap-3 md:grid-cols-[repeat(4,minmax(0,1fr))\_1.35fr] md:gap-2">

      {FILTER_CHAIN.map(({ key, placeholder }, index) => {

        const disabled =

          index > 0 && !selections[FILTER_CHAIN[index - 1].key];

        return (

          <SearchableSelect

            key={key}

            filterKey={key}

            placeholder={placeholder}

            options={facets[key] || []}

            value={selections[key] || ""}

            disabled={index > 0 && disabled}

            onChange={(value) => selectValue(key, value)}

          />

        );

      })}

      <button

        type="button"

        onClick={handleSearch}

        className="agp-finder-submit h-12 w-full rounded-md bg-[#0b7be7] px-5 text-[13px] font-medium text-white transition hover:bg-[#086fd1]"

      >

        SEARCH PART

      </button>

    </div>

  );

}

const BASE = "https://allgoodparts.com.au";

const DESTINATIONS = {

  part: `${BASE}/pages/all-parts`,

  make: `${BASE}/collections/car-wreckers-in-melbourne`,

};

const normalize = (name) => String(name || "").trim().toLowerCase().replace(/[\_-]+/g, " ").replace(/\s+/g, " ");

/* ------------------------------------------------------------------ */
/* Shopify collections → Browse by Make / Browse by Part               */
/* Mirrors the Liquid sections:                                        */
/*   - all collections, sorted by title (Liquid `sort: 'title'`)       */
/*   - custom.type == "Make"        → Browse by Make                   */
/*   - custom.type == "Part-Finder" → Browse by Part                   */
/*   - odd count → drop the last one (even number of cards)            */
/* ------------------------------------------------------------------ */

const DIRECTORY_COLLECTIONS_QUERY = `
  query DirectoryCollections($cursor: String) {
    collections(first: 100, after: $cursor) {
      pageInfo { hasNextPage endCursor }
      nodes {
        handle
        title
        image { url(transform: { maxWidth: 300 }) }
        type: metafield(namespace: "custom", key: "type") { value }
        displayName: metafield(namespace: "custom", key: "display_name") { value }
        products(first: 1) {
          nodes { featuredImage { url(transform: { maxWidth: 300 }) } }
        }
      }
    }
  }
`;

// Liquid `sort: 'title'` is a plain, case-sensitive string sort.
const byTitle = (a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0);

const metaValue = (field) => String(field?.value ?? "").trim();

// Same as the Liquid "remainder == 1 → minus 1" logic.
const evenCount = (list) => list.slice(0, list.length - (list.length % 2));

function buildDirectory(collections) {

  const sorted = [...collections].sort(byTitle);

  const makes = sorted

    .filter((c) => metaValue(c.type) === "Make")

    .map((c) => ({

      // {{ collection.title | remove: ' Wreckers' | strip | replace: ' ', '_' }}

      name: c.title.split(" Wreckers").join("").trim().replace(/ /g, "_"),

      // {{ collection.image }}

      image: c.image?.url || "",

      url: `${BASE}/collections/${c.handle}`,

    }));

  const parts = sorted

    .filter((c) => metaValue(c.type) === "Part-Finder")

    .map((c) => ({

      // {{ collection.metafields.custom.display_name.value | default: collection.title }}

      name: metaValue(c.displayName) || c.title,

      // {{ collection.featured_image }} = collection image, else first product image

      image: c.image?.url || c.products?.nodes?.[0]?.featuredImage?.url || "",

      url: `${BASE}/collections/${c.handle}`,

    }));

  return { make: evenCount(makes), part: evenCount(parts) };

}

let directoryPromise = null;

function loadDirectory() {

  if (directoryPromise) return directoryPromise;

  try {

    const cached = JSON.parse(sessionStorage.getItem(DIRECTORY_CACHE_KEY) || "null");

    if (cached && Date.now() - cached.at < DIRECTORY_CACHE_TTL) {

      directoryPromise = Promise.resolve(cached.data);

      return directoryPromise;

    }

  } catch {
    // storage unavailable – just fetch
  }

  directoryPromise = (async () => {

    const all = [];

    let cursor = null;

    do {

      const res = await fetch(SHOPIFY_GRAPHQL_URL, {

        method: "POST",

        headers: {

          "Content-Type": "application/json",

          "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN,

        },

        body: JSON.stringify({ query: DIRECTORY_COLLECTIONS_QUERY, variables: { cursor } }),

      });

      if (!res.ok) throw new Error(`Shopify API error: ${res.status}`);

      const json = await res.json();

      if (json.errors?.length) throw new Error(json.errors[0].message);

      const page = json.data?.collections;

      all.push(...(page?.nodes || []));

      cursor = page?.pageInfo?.hasNextPage ? page.pageInfo.endCursor : null;

    } while (cursor);

    const data = buildDirectory(all);

    try {

      sessionStorage.setItem(DIRECTORY_CACHE_KEY, JSON.stringify({ at: Date.now(), data }));

    } catch {
      // ignore storage errors
    }

    return data;

  })().catch((error) => {

    directoryPromise = null; // allow a retry on next mount

    throw error;

  });

  return directoryPromise;

}

function useShopifyDirectory() {

  const [state, setState] = useState({ status: "loading", data: null });

  useEffect(() => {

    let alive = true;

    loadDirectory()

      .then((data) => alive && setState({ status: "ready", data }))

      .catch((error) => {

        console.error("Browse directory: Shopify fetch failed.", error);

        if (alive) setState({ status: "error", data: null });

      });

    return () => { alive = false; };

  }, []);

  return state;

}

function DirectoryCarousel({ title, accent, items, kind, loading = false, error = false }) {

  const trackRef = useRef(null);

  const [position, setPosition] = useState({ start: true, end: false });

  const [active, setActive] = useState(0);

  const pointer = useRef(null);

  const [dragging, setDragging] = useState(false);

  const cards = useMemo(() => Array.from(new Map(items.filter((x) => x?.name).map((x) => [normalize(x.name), x])).values()), [items]);

  const measure = useCallback(() => {

    const el = trackRef.current;

    if (!el) return;

    const card = el.querySelector(".agp-dir-card");

    const stride = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap || 0) : 1;

    setActive(Math.max(0, Math.round(el.scrollLeft / Math.max(1, stride))));

    setPosition({ start: el.scrollLeft <= 3, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 3 });

  }, []);

  useEffect(() => {

    measure();

    let frame = null;
    const observer = new ResizeObserver(() => {
      // Avoid synchronous React state updates inside ResizeObserver delivery.
      if (frame !== null) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = null;
        measure();
      });
    });
    if (trackRef.current) observer.observe(trackRef.current);
    return () => {
      observer.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
    };

  }, [measure, cards.length]);

  const slide = (dir) => {

    const el = trackRef.current;

    if (!el) return;

    const card = el.querySelector(".agp-dir-card");

    if (!card) return;

    const stride = card.getBoundingClientRect().width + parseFloat(getComputedStyle(el).gap || 0);

    el.scrollBy({ left: stride * dir, behavior: "smooth" });

  };

  // Each Shopify collection links to its own collection page.
  const itemUrl = (item) => item.url;

  return (

    <section className="agp-dir-section" aria-label={`Browse ${title}`} aria-busy={loading}>

      <div className="agp-dir-heading">

        <div>

          <h2>{title} <span>{accent}</span></h2>

          <p>Swipe or use the arrows to browse more options.</p>

        </div>

        <div className="agp-dir-controls">

          <button type="button" aria-label={`Previous ${title}`} disabled={loading || position.start} onClick={() => slide(-1)}><ChevronLeft size={20} /></button>

          <button type="button" aria-label={`Next ${title}`} disabled={loading || position.end} onClick={() => slide(1)}><ChevronRight size={20} /></button>

        </div>

      </div>

      <div className="agp-dir-track" ref={trackRef} onScroll={measure}

        onPointerDown={(e) => { if (e.pointerType !== "mouse" || e.button !== 0) return; pointer.current = { x: e.clientX, left: e.currentTarget.scrollLeft, moved: false }; }}

        onPointerMove={(e) => { if (!pointer.current) return; const dx = e.clientX - pointer.current.x; if (Math.abs(dx) > 5) { pointer.current.moved = true; setDragging(true); e.currentTarget.scrollLeft = pointer.current.left - dx; } }}

        onPointerUp={() => { if (pointer.current?.moved) { const el = trackRef.current; if (el) { el.dataset.justDragged = "1"; setTimeout(() => { if (el) delete el.dataset.justDragged; }, 100); } } pointer.current = null; setDragging(false); }}

        onPointerCancel={() => { pointer.current = null; setDragging(false); }}

        style={{ cursor: dragging ? "grabbing" : undefined }}>

        {loading

          ? Array.from({ length: 6 }).map((_, i) => (

            <div key={`${kind}-skeleton-${i}`} className={`agp-dir-card agp-dir-card--${kind} agp-dir-card--skeleton`} aria-hidden="true">

              <span className="agp-dir-art"><span className="agp-dir-skel agp-dir-skel-art" /></span>

              <span className="agp-dir-skel agp-dir-skel-text" />

            </div>

          ))

          : cards.length === 0

          ? <div className="agp-dir-empty">{error ? "Couldn't load right now. Please try again later." : "Nothing to show yet."}</div>

          : cards.map((item, i) => (

          <a href={itemUrl(item)} key={`${kind}-${normalize(item.name)}`} className={`agp-dir-card agp-dir-card--${kind}`} draggable="false" onClick={(e) => { if (e.currentTarget.closest(".agp-dir-track")?.dataset.justDragged) e.preventDefault(); }}>

            <span className="agp-dir-art">

              {item.image ? <img src={item.image} alt={String(item.name).replace(/\_/g, " ")} loading={i < 8 ? "eager" : "lazy"} decoding="async" draggable="false" onError={(e) => { e.currentTarget.style.display = "none"; }} /> : kind === "make" ? <CarFront size={36} /> : <Wrench size={36} />}

            </span>

            <span className="agp-dir-name">{String(item.name).replace(/\_/g, " ")}</span>

          </a>

        ))}

      </div>

      <div className="agp-dir-footer">

        <div className="agp-dir-progress" aria-hidden="true"><span style={{ width: `${Math.max(8, 100 * Math.min(1, (active + 1) / Math.max(1, cards.length - 2))) }%` }} /></div>

        <a className="agp-dir-view-all" href={DESTINATIONS[kind]}>VIEW ALL <ChevronRight size={16}/></a>

      </div>

    </section>

  );

}

function PartsDirectoryCarousel({ status, data }) {

  const loading = status === "loading";

  const error = status === "error";

  return (

    <div className="agp-dir-root">

      <DirectoryCarousel title="Browse by" accent="Make" items={data?.make || []} kind="make" loading={loading} error={error} />

      <DirectoryCarousel title="Browse by" accent="Part" items={data?.part || []} kind="part" loading={loading} error={error} />

    </div>

  );

}

const DIRECTORY_STYLES = `
.agp-dir-root{display:grid;gap:14px;padding:12px 0 10px;min-width:0}

.agp-dir-section{background:#fff;border:1px solid #eceef1;border-radius:16px;padding:16px 16px 15px;min-width:0;overflow:hidden}

.agp-dir-heading{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px}

.agp-dir-heading h2{margin:0;font-size:21px;font-weight:750;color:#162033;line-height:1.25}

.agp-dir-heading h2 span{color:#c41620}

.agp-dir-heading p{margin:5px 0 0;color:#8a909a;font-size:12px}

.agp-dir-controls{display:flex;gap:8px;flex-shrink:0}

.agp-dir-controls button{width:36px;height:36px;display:grid;place-items:center;border:1px solid #e0e3e9;background:#fff;border-radius:10px;color:#172039;cursor:pointer;transition:.2s}

.agp-dir-controls button:not(:disabled):hover{background:#c41620;color:#fff;border-color:#c41620}

.agp-dir-controls button:disabled{opacity:.32;cursor:default}

.agp-dir-track{display:flex;gap:16px;overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scroll-padding-left:1px;scrollbar-width:none;padding:2px 2px 12px;user-select:none;-webkit-overflow-scrolling:touch;touch-action:pan-x pan-y}

.agp-dir-track::-webkit-scrollbar{display:none}

.agp-dir-card{flex:0 0 calc((100% - 80px)/6);min-width:0;min-height:142px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:12px 8px;background:#fafafa;border:1px solid #e0e2e6;border-radius:12px;text-decoration:none!important;color:#30343c;scroll-snap-align:start;box-shadow:0 2px 5px #0f172a08;transition:border-color .2s,box-shadow .2s,transform .2s}

.agp-dir-card:hover,.agp-dir-card:focus-visible{border-color:#d01d2a;box-shadow:0 5px 14px #0f172a16;transform:translateY(-2px);outline:none}

.agp-dir-art{height:67px;width:100%;display:grid;place-items:center;color:#a7aab1;pointer-events:none}

.agp-dir-art img{max-width:100%;width:auto;height:64px;object-fit:contain;pointer-events:none}

.agp-dir-card--part .agp-dir-art{width:80px;height:80px;border-radius:50%;background:#fff5f5;border:1px solid #f4d5d7}

.agp-dir-card--part .agp-dir-art img{height:56px;max-width:65px}

.agp-dir-name{font-size:13px;font-weight:650;text-align:center;line-height:1.35;text-transform:capitalize;overflow-wrap:anywhere;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}

.agp-dir-footer{display:flex;align-items:center;justify-content:center;position:relative;min-height:62px;padding-top:12px}

.agp-dir-progress{position:absolute;left:0;bottom:14px;width:88px;height:4px;border-radius:5px;background:#ebedf1;overflow:hidden}

.agp-dir-progress span{display:block;height:100%;border-radius:5px;background:#bf1320;transition:width .2s}

.agp-dir-view-all{display:inline-flex;justify-content:center;align-items:center;gap:9px;min-width:155px;min-height:43px;padding:0 18px;border:2px solid #b90e1a;border-radius:99px;font-size:12px;font-weight:750;color:#b90e1a;text-decoration:none!important;transition:.2s}

.agp-dir-view-all:hover{background:#b90e1a;color:#fff}

.agp-dir-empty{flex:1;padding:40px 12px;text-align:center;color:#8a909a;font-size:13px}

.agp-dir-card--skeleton{pointer-events:none;box-shadow:none}

.agp-dir-skel{display:block;border-radius:8px;background:linear-gradient(90deg,#eef0f3 25%,#f7f8fa 50%,#eef0f3 75%);background-size:200% 100%;animation:agp-dir-shimmer 1.2s linear infinite}

.agp-dir-skel-art{width:64px;height:48px}

.agp-dir-card--part .agp-dir-skel-art{width:48px;height:48px;border-radius:50%}

.agp-dir-skel-text{width:70%;height:12px}

@keyframes agp-dir-shimmer{from{background-position:200% 0}to{background-position:-200% 0}}

@media(prefers-reduced-motion:reduce){.agp-dir-skel{animation:none}}

@media(max-width:1023px){.agp-dir-card{flex-basis:calc((100% - 48px)/4)}}

@media(max-width:767px){.agp-dir-root{gap:14px;padding:14px 0}.agp-dir-section{padding:15px 12px 13px;border-radius:12px}.agp-dir-heading{margin-bottom:13px}.agp-dir-heading h2{font-size:17px}.agp-dir-heading p{font-size:10px}.agp-dir-controls button{width:31px;height:31px;border-radius:8px}.agp-dir-track{gap:10px}.agp-dir-card{flex-basis:calc((100% - 10px)/2);min-height:126px;padding:9px 6px}.agp-dir-name{font-size:12px}.agp-dir-art{height:61px}.agp-dir-art img{height:58px}.agp-dir-card--part .agp-dir-art{height:67px;width:67px}.agp-dir-card--part .agp-dir-art img{height:48px}.agp-dir-footer{min-height:57px}.agp-dir-view-all{min-width:120px;min-height:39px;font-size:11px}.agp-dir-progress{width:50px;bottom:17px}}

`;

export default function FindPartsPage() {

  const [requestOpen, setRequestOpen] = useState(false);

  // One Shopify fetch feeds both carousels and the finder dropdown icons.
  const directory = useShopifyDirectory();

  const imageMaps = useMemo(() => buildImageMaps(directory.data), [directory.data]);

  const isAppView = new URLSearchParams(

    window.location.search

  ).get("app") === "1";

  const handleSearch = (params) => {

    const query = new URLSearchParams(params).toString();

    window.location.href = `${MAIN_DOMAIN}/collections/all?${query}`;

  };

  const pageContent = (

    <DirectoryImagesContext.Provider value={imageMaps}>
    <main className="agp-find-page min-h-screen bg-[#f7f7f8] pb-8">
      <style>{DIRECTORY_STYLES}</style>

      <div className="agp-page-wrap agp-find-page-wrap">

        <section className="agp-find-hero" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,.69), rgba(0,0,0,.75)), url(${heroBg})` }}>

          <h1 className="agp-find-title">Find <span>Parts</span></h1>

          <PartsFinder onSearch={handleSearch} />

          <div className="agp-find-help">

            <Info size={14} fill="white" color="#303030" />

            <span>Need help finding a part?</span>

            <button type="button" onClick={() => setRequestOpen(true)}>Click here</button>

          </div>

        </section>

        <div className="agp-find-directories"><PartsDirectoryCarousel status={directory.status} data={directory.data} /></div>

      </div>

      <RequestPartModal

        open={requestOpen}

        onClose={() => setRequestOpen(false)}

        onSubmitted={() => { setRequestOpen(false); window.location.href = "/quotes"; }}

      />

    </main>
    </DirectoryImagesContext.Provider>

  );

  return isAppView

    ? pageContent

    : <UserLayout>{pageContent}</UserLayout>;

}
